import React from "react";
import Icon from "../assets/img/card_icon.png";
export default function IncludedServices({ includedSectionData }) {
  const {
    leftSection,
    rightSection,
    leftColumnContent = [],
    rightColumnContent = [],
  } = includedSectionData;

  // First two items for the top-left section
  const topLeftItems = leftColumnContent.slice(0, 2);

  // Remaining items after the image area
  const remainingItems = [...leftColumnContent.slice(2), ...rightColumnContent];

  return (
    <section className="included-section bg-[#0C2C66] text-white">
      {/* GRID ONLY FOR DESKTOP/TABLET */}
      <div className="hidden md:grid md:grid-cols-2 md:gap-10 lg:gap-16">
        {/* LEFT SIDE: HEADER + INTRO + FIRST 2 ITEMS */}
        <div className="flex flex-col space-y-8 included-sec-left-top">
          {/* Header + intro */}
          <div>
            <h2 className="text-3xl lg:text-4xl font-bold mb-4">
              {leftSection.header}
            </h2>
            <p className="text-gray-200 max-w-xl leading-relaxed">
              {leftSection.desc}
            </p>
          </div>

          {/* First two items */}
          {topLeftItems.map((item, i) => (
            <div key={i} className="flex gap-4">
              <img src={Icon} style={{ width: "35px", height: "35px" }} />

              <div>
                <h3 className="text-lg font-semibold">{item.title}</h3>
                <p className="included-sec-desc-element text-gray-300">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* RIGHT IMAGE spanning all 3 rows */}
        <div className="row-span-3">
          <img
            src={rightSection.img}
            alt="Students"
            className="w-full h-full object-cover rounded-md included-sec-img"
          />
        </div>

        {/* Remaining grid (below image) – 2 columns */}
        <div
          style={{ padding: "0% 7%", paddingBottom: "5%" }}
          className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-10 "
        >
          {remainingItems.map((item, i) => (
            <div key={i} className="flex gap-4">
              <img src={Icon} style={{ width: "35px", height: "35px" }} />

              <div>
                <h3 className="text-lg font-semibold">{item.title}</h3>
                <p className="included-sec-desc-element text-gray-300">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* MOBILE VIEW (STACK EVERYTHING, IMAGE LAST) */}
      <div className="md:hidden flex flex-col space-y-8 mt-6  included-section-mobile">
        {/* Header */}
        <h2 className="text-3xl font-bold p-4 text-[28px]">
          {leftSection.header}
        </h2>
        <p className="text-gray-200 p-4 text-[20px]">{leftSection.desc}</p>

        {/* All items stacked */}
        <div className="p-4 text-left">
          {[...leftColumnContent, ...rightColumnContent].map((item, i) => (
            <div key={i} className="flex gap-4 mt-8">
              <img
                className="mt-1"
                src={Icon}
                style={{ width: "28px", height: "28px" }}
              />
              <div>
                <h3 className="text-lg font-semibold text-[20px]">
                  {item.title}
                </h3>
                <p className="included-sec-desc-element text-gray-300 text-[16px]">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Image LAST on mobile */}
        <img
          src={rightSection.img}
          alt="Students"
          className=" mt-6 bg-[#fff]"
        />
      </div>
    </section>
  );
}
